<template>
  <component :is="editorSelecionado" />
</template>

<script>
import CadastroFluxo from "./CadastroFluxo.vue";
import CadastroFluxoNovo from "./CadastroFluxoNovo.vue";

const PREFERENCIA_EDITOR = "usuario_config";

function preferenciaEditorNovo() {
  try {
    const configuracao = JSON.parse(
      localStorage.getItem(PREFERENCIA_EDITOR) || "{}"
    );
    return configuracao?.editor_novo !== false;
  } catch (error) {
    return true;
  }
}

export default {
  name: "EditorFluxo",
  components: { CadastroFluxo, CadastroFluxoNovo },
  data() {
    return { editorNovo: preferenciaEditorNovo() };
  },
  computed: {
    editorSelecionado() {
      return this.editorNovo ? "CadastroFluxoNovo" : "CadastroFluxo";
    }
  },
  created() {
    this.atualizarEditor = (editorNovo) => {
      this.editorNovo = Boolean(editorNovo);
    };
    this.$root.$on("fluxo:alternar-editor", this.atualizarEditor);
  },
  beforeDestroy() {
    this.$root.$off("fluxo:alternar-editor", this.atualizarEditor);
  }
};
</script>
